import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-carvet-right",
  "use": "arrow-carvet-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-carvet-right\"><path d=\"M6 4.438c0-.376.405-.576.663-.329l3.2 3.063a.465.465 0 010 .658l-3.2 3.063c-.258.247-.663.046-.663-.33V4.439z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol